<template>
    <div>

        <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }">

            <template #title>
                <a-row>
                    <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                        <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
                                <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span
                                class="ml-5 text-danger font-weight-bold">HRD Budget Report</span>
                        </h6>
                        <p style="font-size: 12px;" class="font-web mt-5 mb-0 ml-20">&nbsp;&nbsp; HRD Budget Report</p>
                    </a-col>
                </a-row>
            </template>

            <a-form style="padding: 10px;">

                <a-space :size="20" class=" mt-10 mb-10 ">
                    
                    <a-button type="primary" @click="addPerson" icon="plus">
                        Add Person
                    </a-button>
                </a-space>

                <div v-for="(person, index) in people" :key="index"
                    style="margin-bottom: 16px; border-bottom: 1px dashed #ccc; padding-bottom: 8px;">
                    <a-row :gutter="16">
                        <a-col :span="8">
                            <a-form-item>
                                <template slot="label">
                                    <a-button v-if="index > 0" type="danger" size="sm" class="mr-5" icon="user-delete"
                                        @click="removePerson(index)" /> Name & Surname
                                </template>
                                <a-input v-model="person.name" placeholder="Name-Surname" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="`Position`">
                                <a-input v-model="person.position" placeholder="Position" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="`Division`">
                                <a-input v-model="person.division" placeholder="Division" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                </div>

                <div>
                    <a-row :gutter="24">
                        <!-- Subject/Title -->
                        <a-col :span="12">
                            <a-form-item label="Subject / Title">
                                <a-input v-model="form.subject" placeholder="Enter subject/title" />
                            </a-form-item>
                        </a-col>
                        <!-- Held by -->
                        <a-col :span="12">
                            <a-form-item label="Held by">
                                <a-input v-model="form.heldBy" placeholder="Enter held by" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <!-- Start Date - to -->
                        <a-col :span="12">
                            <a-form-item label="Start Date - To">
                                <a-range-picker v-model="form.dateRange" style="width: 100%;" />
                            </a-form-item>
                        </a-col>
                        <!-- Period (Year / Month / Day / Hour) -->
                        <a-col :span="12">
                            <a-form-item label="Period ( Year / Month / Day / Hour )">
                                <a-input v-model="form.period" placeholder="e.g. 1 Year 2 Months" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <!-- Location -->
                        <a-col :span="12">
                            <a-form-item label="Location">
                                <a-input v-model="form.location" placeholder="Enter location" />
                            </a-form-item>
                        </a-col>
                        <!-- Total Expense -->
                        <a-col :span="12">
                            <a-form-item label="Total Expense ( Bath )">
                                <a-input-number v-model="form.totalExpense" :min="0" style="width: 100%;" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <div>
                    <a-form-item label="Course Content Summary">
                        <a-textarea placeholder="Basic usage" :rows="4" />
                    </a-form-item>
                </div>

                <div>
                    <a-form-item
                        label="If the training will lead to any change of working practice in your own job, please give details below:">
                        <a-textarea placeholder="Basic usage" :rows="4" />
                    </a-form-item>
                </div>

                <div>
                    <p class="font-web mt-0 mb-0">Comments regarding the training course</p>
                    <a-form-item label="Course Content: ">
                        <a-input v-model="form.subject" placeholder="Enter subject/title" />
                    </a-form-item>
                    <a-form-item label="Speaker: ">
                        <a-input v-model="form.subject" placeholder="Enter subject/title" />
                    </a-form-item>
                    <a-form-item label="Equipment: ">
                        <a-input v-model="form.subject" placeholder="Enter subject/title" />
                    </a-form-item>
                    <a-form-item label="Venue and Timing: ">
                        <a-input v-model="form.subject" placeholder="Enter subject/title" />
                    </a-form-item>
                </div>

                <div>
                    <a-form-item
                        label="Do you agree if the college will send our staff to participate in this course in the future ?">
                        <a-textarea placeholder="Basic usage" :rows="4" />
                    </a-form-item>
                </div>

                <div>
                    <a-form-item
                        label="Please specify the course that you are interesting to participate in the future.">
                        <a-textarea placeholder="Basic usage" :rows="4" />
                    </a-form-item>
                </div>

                <!-- Submit -->
                <div class="text-center">
                    <a-button type="primary" @click="addPerson" icon="plus">
                        Submit
                    </a-button>
                </div>

            </a-form>
        </a-card>

    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                subject: '',
                heldBy: '',
                dateRange: [],
                period: '',
                location: '',
                totalExpense: null,
            },
            people: [
                { name: '', position: '', division: '' }
            ]
        }
    },
    methods: {
        gotoMainType() {
            if (this.$store.state.role.RulesUser.username.split('.').length === 2) {
                this.$router
                    .push({
                        path: "/hri/request",
                    })
                    .catch((err) => { });
            } else {
                this.$router
                    .push({
                        path: "/hri/",
                    })
                    .catch((err) => { });
            }
        },
        addPerson() {
            this.people.push({ name: '', position: '', division: '' });
        },
        removePerson(index) {
            this.people.splice(index, 1);
        },
        submit() {
            console.log('Submitted people:', this.people);
        }
    }
}
</script>

<style scoped>
.f-14 {
    font-size: 14px;
}

.spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
}
</style>